// Declares the cascade layer order, so it must load before web-ui's CSS
import './legacy-ui-compat.css'
import '@workwhile/web-ui/dist/index.css'

import { ReactNode } from 'react'
import { StyleSheetManager } from 'styled-components'
import { ThemeProvider as LegacyThemeProvider } from '@workwhile/ui'
import {
  ThemeProvider as WebUiThemeProvider,
  ThemeProviderProps as WebUiThemeProviderProps,
} from '@workwhile/web-ui'
import { legacyUiStylisPlugin } from './legacyUiStylisPlugin'

const stylisPlugins = [legacyUiStylisPlugin]

interface ThemeProvidersProps {
  children?: ReactNode
  googleMapsApiKey?: string
  env?: WebUiThemeProviderProps['env']
}

export const ThemeProviders = ({
  children,
  googleMapsApiKey,
  env,
}: ThemeProvidersProps) => (
  <StyleSheetManager stylisPlugins={stylisPlugins}>
    <LegacyThemeProvider googleMapsApiKey={googleMapsApiKey}>
      <WebUiThemeProvider env={env}>{children}</WebUiThemeProvider>
    </LegacyThemeProvider>
  </StyleSheetManager>
)
